export type RequestProductCategory =
	| 'fertilizer'
	| 'lime'
	| 'conditioner'
	| 'organic'
	| 'special'
	| 'defensive';

export type RequestProductStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export type ClientProductRequestTab = 'pending' | 'approved' | 'rejected' | 'all';

export const CATEGORY_LABELS: Record<RequestProductCategory, string> = {
	fertilizer: 'Fertilizante',
	lime: 'Corretivo',
	conditioner: 'Condicionador',
	organic: 'Organomineral',
	special: 'Especial / Bioestimulante',
	defensive: 'Defensivo',
};

export const STATUS_LABELS: Record<RequestProductStatus, string> = {
	PENDING: 'Pendente',
	APPROVED: 'Aprovado',
	REJECTED: 'Rejeitado',
};

export interface ClientProductRequest {
	_id: string;
	name: string;
	manufacturer: string;
	category: RequestProductCategory;
	note?: string;
	reason?: string;
	status: RequestProductStatus;
	userName: string;
	userId: string;
	createdAt: string;
	updatedAt: string;
}

export interface ProductRequestFormData {
	name: string;
	manufacturer: string;
	category: RequestProductCategory | '';
	note: string;
}

